export const copyToClipboard = (textToCopy: any) =>
  navigator.clipboard.writeText(textToCopy);
